import {
  vEmail,
  vNonEmptyString,
  vObject,
  type vOutput,
} from '../validation/index.ts'

export const forgotPasswordSchema = vObject({
  email: vEmail,
})
export type ForgotPasswordModel = vOutput<typeof forgotPasswordSchema>

export const changePasswordSchema = vObject({
  currentPassword: vNonEmptyString(),
  newPassword: vNonEmptyString(),
})

export type ChangePasswordDTO = vOutput<typeof changePasswordSchema>
